import type { Form } from '../../../../common/types/form';
import type { Child } from '../../../../common/types/child';

const childCareDataForm: Form<Child> = {
  key: 'childCareData',
  title: 'Kinderbetreuung während Frauenhaus',
  fields: [
    {
      key: 'oldChildCareSince',
      label: 'seit',
      fieldTypes: 'date',
      breakRowAfterField: true,
    },
    {
      key: 'childCare',
      label: 'KG/Krippe/Hort',
      fieldTypes: 'select',
      options: [],
    },
    {
      key: 'childCareGroup',
      label: 'Gruppe',
      fieldTypes: 'text',
    },
    {
      key: 'childCareAdress',
      label: 'Adresse',
      fieldTypes: 'text',
      xsWidth: 12,
    },
    {
      key: 'childCareContactPerson',
      label: 'Ansprechperson',
      fieldTypes: 'text',
    },
    {
      key: 'childCareManagement',
      label: 'KiGa Leitung',
      fieldTypes: 'text',
    },
    {
      key: 'isExcusedChildCare',
      label: 'Entschuldigt',
      fieldTypes: 'checkbox',
    },
    {
      key: 'isDisenrolledChildCare',
      label: 'Abmeldung erfolgt',
      fieldTypes: 'checkbox',
    },
    {
      key: 'childCareNotice',
      label: 'Notiz',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
  ],
};

export default childCareDataForm;
